import { anyReallyAny } from "@cervval.js/common/tools";

export interface EditListOnDataChangeEvent<T = anyReallyAny> {

    /** New edited data */
    editedData: T[];
}

export enum EditListEvents {
    EDITED_DATA_CHANGED = "editedDataChanged"
}